import React, { useState, useEffect, useCallback } from "react";

const Timer = ({
  totalTimeInSeconds,
  endingMinutes = 30,
  textWithTimer = null,
  textColor = null,
  onTimerEnd = null,
}) => {
  const [lapsed, setLapsed] = useState(totalTimeInSeconds);
  const [isEnding, setIsEnding] = useState(false);

  useEffect(() => {
    if (lapsed <= endingMinutes * 60) {
      setIsEnding(true);
    } else {
      setIsEnding(false);
    }
  }, [lapsed, endingMinutes]);

  const updateTimer = useCallback(() => {
    setLapsed((prevLapsed) => {
      const newLapsed = prevLapsed <= 0 ? 0 : prevLapsed - 1;
      if (newLapsed <= 0 && onTimerEnd) {
        onTimerEnd();
      }
      return newLapsed;
    });
  }, [onTimerEnd]);

  useEffect(() => {
    const timer = setInterval(updateTimer, 1000);
    return () => clearInterval(timer);
  }, [updateTimer]);

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  return (
    <div
      className={`open-countdown btn btn-sm ${
        isEnding ? "end-limit" : "in-limit"
      }`}
      style={textColor ? { color: textColor } : {}}
    >
      {textWithTimer ? textWithTimer : ""}
      {formatTime(lapsed)}
    </div>
  );
};

export default Timer;
